import { render, staticRenderFns } from "./LocationAttrs.vue?vue&type=template&id=d08bbd5c"
import script from "./LocationAttrs.vue?vue&type=script&lang=js"
export * from "./LocationAttrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports